import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from '../constent';


export const fetchAreas = createAsyncThunk(
  "areas/fetchAreas",
  async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${BASE_URL}/area`);
    // console.log(response.data.data)
    return response.data.data;
  } catch (error) {
    return rejectWithValue("Failed to fetch areas");
  }
});

export const UpdateArea = createAsyncThunk(
  "areas/UpdateArea",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      // console.log(id)
      // console.log(data)
      const token = localStorage.getItem("accessToken");
      
      const response = await axios.put(`${BASE_URL}/area/${id}`, data, {
        headers: {
          token: token
        },
      });
  
      return response.data;
    } catch (error) {
      // console.log("Error response:", error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to update order");
    }
  }
);



const AreasSlice = createSlice({
  name: 'areas',
  initialState: {
    allAreas: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAreas.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAreas.fulfilled, (state, action) => {
        state.areas = action.payload;
        state.loading = false;
      })
      .addCase(fetchAreas.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })    
  },
});
export default AreasSlice.reducer;



// Export actions and reducer

